import React, { useContext } from 'react'
import { Link } from 'react-router-dom'

import { OrgUsersById, OrgUsersContext } from 'context/orgUsersContext'
import { ActivityForContact, ActivityType } from 'modules/accountActivity/domain'
import {
  activityTypeToStringDescription,
  activityTypeToWord,
  prefixUrlWithHttp
} from 'utils/activity'

import utilityStyles from '../../../styles/utility.module.css'
import styles from './styles.module.css'

interface FormattedActivityProps {
  activity: ActivityForContact
  displayName?: string
  email?: string
  showActivityType?: boolean
}

const toLowerFirstChar = (str?: string) => str?.replace(/^./, c => c.toLowerCase())

const FormattedActivity: React.FC<FormattedActivityProps> = ({
  activity,
  displayName,
  email,
  showActivityType = true
}) => {
  const orgUsersById = useContext<OrgUsersById>(OrgUsersContext)

  const activityTitle = activity.activityContext.pageTitle || activity.activityContext.title
  const activityUrl = activity.activityContext.pageUrl || activity.activityContext.url
  const conversationId =
    activity.activityType === ActivityType.CONVERSATION ? activity?.activityContext?.id : null

  return (
    <div className={styles.activityDescription}>
      {showActivityType && (
        <span className={utilityStyles.semiBoldWeight}>
          {activityTypeToStringDescription(activity)}
        </span>
      )}
      {displayName && <span>{displayName}</span>}
      <span className={styles.textNowrap}>
        {toLowerFirstChar(activityTypeToWord(activity, orgUsersById))}
      </span>
      {conversationId && (
        <Link
          className={styles.conversationLink}
          to={{
            pathname: `/conversations/${conversationId}`,
            state: { navigatedFrom: 'Account activity' }
          }}>
          {`"${activity.activityContext.conversationPreview}"`}
        </Link>
      )}
      {activityUrl && (
        <a
          className={styles.activityLink}
          href={prefixUrlWithHttp(activityUrl)}
          target="_blank"
          rel="noreferrer noopener"
          onClick={e => e.stopPropagation()}>
          {activityTitle ?? activityUrl}
        </a>
      )}
      {activity.activityType === ActivityType.END_USER_IDENTIFIED && email && <span>{email}</span>}
      {activity.activityType === ActivityType.CONVERSATION && <span>{' in a conversation'}</span>}
      {activity.activityContext.fromOutreach && <span>{' via Outreach'}</span>}
    </div>
  )
}

export default FormattedActivity
